// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pv-0";